import { AliExpressId, AmazonId, LazadaId, ShopeeId } from '../constants'
import { ECHARTS_COLOR_1_6, ECHARTS_COLOR_6_12, ECHARTS_COLOR_12_18, ECHARTS_COLOR_18_24, ECHARTS_COLOR_24_30 } from './color'

export {
  ECHARTS_COLOR_1_6,
  ECHARTS_COLOR_6_12,
  ECHARTS_COLOR_12_18,
  ECHARTS_COLOR_18_24,
  ECHARTS_COLOR_24_30,
}

export const PLUGIN_HELPER_TASK_STATUS_ENUM = {
  created: {
    code: 0,
    name: '待执行',
    value: 0,
    label: '待执行',
  },
  processing: {
    code: 100,
    name: '执行中',
    value: 100,
    label: '执行中'
  },
  reportGenerating: {
    code: 101,
    name: '报表生成中',
    value: 101,
    label: '报表生成中',
    isWaitExe: true,
  },
  success: {
    code: 300,
    name: '成功',
    value: 300,
    label: '成功'
  },
  fail: {
    code: 400,
    name: '失败',
    value: 400,
    label: '失败'
  },
}

export const PLUGIN_HELPER_TASK_TYPE_ENUM = {
  type4: {
    literal: 'type4',
    label: 'Detail Page Sales and Traffic By Child Item',
    value: 4,
    code: 4,
    name: 'Detail Page Sales and Traffic By Child Item',
    visible: true,
    // 是否已经开放
    public: true,
  },
  type100: {
    literal: 'type100',
    label: 'Payments Dashboard',
    value: 100,
    code: 100,
    name: 'Payments Dashboard',
    visible: false,
    public: true,
  },
  // 生成日期范围报告
  PAYMENTS_GEN_DATE_RANGE_REPORTS: {
    code: 101,
    name: 'payments generate date range reports',
    visible: false,
    // new gen
    literal: 'PAYMENTS_GEN_DATE_RANGE_REPORTS',
    label: 'payments generate date range reports',
    value: 101,
    public: true,
  },
  // amaozn 补货限制
  amazonInventoryPerformance: {
    code: 300001,
    name: 'inventory performance',
    visible: false,
    literal: 'amazonInventoryPerformance',
    label: 'inventory performance',
    value: 300001,
    public: true,
  },
  // alipayGlobal 财务动账 账户余额
  aliExpressAlipayGlobalFinanceAccountBalance: {
    code: 100001,
    name: '财务动账',
    visible: true,
    literal: 'aliExpressAlipayGlobalFinanceAccountBalance',
    label: '财务动账',
    value: 100001,
    public: true,
  },
  // 速卖通 菜鸟 金掌柜 账单
  aliExpressJzgBill: {
    name: '金掌柜',
    code: 100002,
    visible: true,
    literal: 'aliExpressJzgBill',
    label: '金掌柜',
    value: 100002,
    public: true,
  },
  // 速卖通 资金 俄罗斯账单
  aliExpressRussiaBill: {
    literal: 'aliExpressRussiaBill',
    label: '俄罗斯账单',
    value: 100003,
    name: '俄罗斯账单',
    code: 100003,
    visible: false,
    public: false,
  },
  // 速卖通 资金 俄罗斯账单
  aliExpressRussiaBillUsd: {
    literal: 'aliExpressRussiaBillUsd',
    label: '俄罗斯账单',
    value: 100004,
    name: '俄罗斯账单',
    code: 100004,
    visible: false,
    public: false,
  },
  // amaozn 秒杀推荐
  amazonDealRecommendations: {
    code: 300002,
    name: 'Eligible Products to Run a Deal',
    visible: false,
    literal: 'amazonDealRecommendations',
    label: 'Eligible Products to Run a Deal',
    value: 300002,
    public: true,
  },
}

export const PLUGIN_HELPER_PLUGIN_STATUS_ENUM = {
  offline: {
    code: 0,
    name: '离线',
  },
  online: {
    code: 1,
    name: '在线',
  },
}

export const PLUGIN_HELPER_TASK_SOURCE_ENUM = {
  auto: {
    code: 'auto',
    name: '自动',
  },
  manual: {
    code: 'manual',
    name: '手动',
  },
}

export const FEE_MGT_SHARE_RULES_ENUM = {
  DEFAULT: {
    // 字面量
    literal: 'DEFAULT',
    // 值
    value: 0,
    // 显示的 label
    label: '默认',
  },
  PRODUCT_PERCENTAGE_OF_SALES_VOLUME: {
    literal: 'PRODUCT_PERCENTAGE_OF_SALES_VOLUME',
    value: 1,
    label: '商品销售额占比',
  },
  PRODUCT_ERCENTAGE_OF_SALES: {
    literal: 'PRODUCT_ERCENTAGE_OF_SALES',
    value: 2,
    label: '商品销量占比',
  },
  SHARE_EQUALLY_BY_PRODUCT_TYPE: {
    literal: 'SHARE_EQUALLY_BY_PRODUCT_TYPE',
    value: 3,
    label: '按商品种类均摊',
  },
  PERCENTAGE_OF_SALES_VOLUME: {
    literal: 'PERCENTAGE_OF_SALES_VOLUME',
    value: 4,
    label: '销售额占比',
  },
  PERCENTAGE_OF_SALES: {
    literal: 'PERCENTAGE_OF_SALES',
    value: 5,
    label: '销量占比',
  },
  SHARE_BY_DAY: {
    literal: 'SHARE_BY_DAY',
    value: 6,
    label: '按天均摊',
  },
}

/**
 * 维度枚举
 */
export const DIMENSION_ENUM = {
  order: {
    literal: 'order',
    label: '订单',
    value: 3,
  },
  childOrder: {
    literal: 'childOrder',
    label: '子订单',
    value: 4,
  },
  sku: {
    literal: 'sku',
    label: 'SKU',
    value: 0,
  },
  spu: {
    literal: 'spu',
    label: 'SPU',
    value: 1,
  },
  shop: {
    literal: 'shop',
    label: '店铺',
    value: 2,
  },
}

// 全局利润报表的维度
export const DIMENSION_PROFIT_SETTLEMENT_GLOBAL_ENUM = {
  platform: {
    literal: 'platform',
    label: '平台',
    value: 1,
  },
  shop: {
    literal: 'shop',
    label: '店铺',
    value: 2,
  },
  sku: {
    literal: 'sku',
    label: 'SKU',
    value: 3,
  },
  country: {
    literal: 'country',
    label: '国家',
    value: 4,
  },
}

/**
 * 本土店 非本土店
 */
export const KJ_TYPE_LOCAL_SHOP_ENUM = {
  localShop: {
    literal: 'localShop',
    label: '本土',
    value: 1,
  },
  crossShop: {
    literal: 'crossShop',
    label: '跨境',
    value: 2,
  },
}

/**
 * 财务 成本计算方式
 */
export const FINANCE_COST_COMPUTE_WAY_ENUM = {
  fixedValue: {
    literal: 'fixedValue',
    value: 1,
    label: '按固定值，取值于费用管理模块设置的采购成本和头程费用'
  },
  inventoryCost: {
    literal: 'inventoryCost',
    value: 2,
    label: '按出库时的存货成本，取值于仓库移动加权平均计算的成本',
  },
  inventoryCostPriority: {
    literal: 'inventoryCostPriority',
    value: 3,
    label: '优先按出库时的存货成本，成本缺失时使用固定值',
  }
}

/**
 * 时间类型枚举
 */
export const TIME_TYPE_ENUM = {
  exchangeTime: {
    literal: 'exchangeTime',
    label: '交易时间',
    value: 0
  },
  orderTime: {
    literal: 'orderTime',
    label: '下单时间',
    value: 1
  },
  sendTime: {
    literal: 'sendTime',
    label: '发货时间',
    value: 2
  },
  settlementTIme: {
    literal: 'settlementTIme',
    label: '结算时间',
    value: 3
  },
  createTime: {
    literal: 'createTime',
    label: '创建时间',
    value: 4
  },
  dateTime: {
    literal: 'dateTime',
    label: '日期',
    value: 5
  },
  writeOffTime: {
    literal: 'writeOffTime',
    label: '核销时间',
    value: 6
  },
  billsTime: {
    literal: 'billsTime',
    label: '单据时间',
    value: 7
  },
  payTime: {
    literal: 'payTime',
    label: '付款时间',
    value: 8
  },
  transferTime: {
    literal: 'transferTime',
    label: '转账时间',
    value: 9
  },
  updateTime: {
    literal: 'updateTime',
    label: '更新时间',
    value: 10
  },
  receiptPaymentTime: {
    literal: 'receiptPaymentTime',
    label: '收付时间',
    value: 11
  },
  platformOrderTime: {
    literal: 'platformOrderTime',
    label: '平台下单时间',
    value: 12,
  },
  platformPayTime: {
    literal: 'platformPayTime',
    label: '平台付款时间',
    value: 13,
  },
}
/**
 * 工单来源
 */
export const TICKET_SOURCE_TYPE_ENUM = {
  requestFunds: {
    literal: 'requestFunds',
    label: '费用请款单',
    value: 1
  },
  handMade: {
    literal: 'handMade',
    label: '手工创建',
    value: 2
  },
  purchaseCash: {
    literal: 'purchaseCash',
    label: '采购请款单',
    value: 3
  },
}

/**
 * 交易类型
 */
export const TRANSACTION_TYPE_ENUM = {
  payment: {
    literal: 'payment',
    label: '付款',
    value: 1
  },
  income: {
    literal: 'income',
    label: '收款',
    value: 2
  },
}

/**
 * 业务类型
 */
export const BUSINESS_TYPE_ENUM = {
  otherPayment: {
    literal: 'otherPayment',
    label: '其他付款',
    value: 1
  },
  otherIncome: {
    literal: 'otherIncome',
    label: '其他收款',
    value: 2
  },
  transferIn: {
    literal: 'transferIn',
    label: '转入',
    value: 3
  },
  transferOut: {
    literal: 'transferOut',
    label: '转出',
    value: 4
  },
  purchasePay: {
    literal: 'purchasePay',
    label: '采购付款',
    value: 5
  },
}

/**
 * 收付款单状态
 */

export const RECEIPT_PAYMENT_TYPE_ENUM = {
  pendingReview: {
    literal: 'pendingReview',
    label: '待审核',
    value: 1,
  },
  reject: {
    literal: 'reject',
    label: '已驳回',
    value: 2,
  },
  audited: {
    literal: 'audited',
    label: '已审核',
    value: 3,
  },
}

/**
 * 工单号类型
 */
export const TICKET_TYPE_ENUM = {
  receiptPaymentNum: {
    literal: 'receiptPaymentNum',
    label: '收付单号',
    value: 0
  },
  requestFundsNum: {
    literal: 'requestFundsNum',
    label: '请款单号',
    value: 1
  },
}

// 异步下载 code
export const ASYNC_EXPORT_CODE_ENUM = {
  EXCEL_LAZADA_PROFIT_ORDER: {
    literal: 'EXCEL_LAZADA_PROFIT_ORDER',
    label: 'Lazada利润报表订单',
    value: 'EXCEL_LAZADA_PROFIT_ORDER'
  },
  EXCEL_LAZADA_PROFIT_ORDER_DETAIL: {
    literal: 'EXCEL_LAZADA_PROFIT_ORDER_DETAIL',
    label: 'Lazada利润报表子订单',
    value: 'EXCEL_LAZADA_PROFIT_ORDER_DETAIL'
  },
  EXCEL_LAZADA_PROFIT_SKU: {
    literal: 'EXCEL_LAZADA_PROFIT_SKU',
    label: 'Lazada利润报表SKU',
    value: 'EXCEL_LAZADA_PROFIT_SKU'
  },
  EXCEL_LAZADA_PROFIT_SHOP: {
    literal: 'EXCEL_LAZADA_PROFIT_SHOP',
    label: 'Lazada利润报表shop',
    value: 'EXCEL_LAZADA_PROFIT_SHOP'
  },
  EXCEL_LAZADA_ORDER: {
    literal: 'EXCEL_LAZADA_ORDER',
    label: 'Lazada结算明细订单',
    value: 'EXCEL_LAZADA_ORDER'
  },
  EXCEL_LAZADA_ITEM: {
    literal: 'EXCEL_LAZADA_ITEM',
    label: 'Lazada结算明细子订单',
    value: 'EXCEL_LAZADA_ITEM'
  },
  EXCEL_LAZADA_TRANSACTION: {
    literal: 'EXCEL_LAZADA_TRANSACTION',
    label: 'Lazada费用明细',
    value: 'EXCEL_LAZADA_TRANSACTION'
  },
  EXCEL_SHOPEE_ORDERS: {
    literal: 'EXCEL_SHOPEE_ORDERS',
    label: 'shopee结算明细订单维度',
    value: 'EXCEL_SHOPEE_ORDERS'
  },
  EXCEL_SHOPEE_ORDER_ITEMS: {
    literal: 'EXCEL_SHOPEE_ORDER_ITEMS',
    label: 'shopee结算明细子单维度',
    value: 'EXCEL_SHOPEE_ORDER_ITEMS'
  },
  EXCEL_SHOPEE_ADJUSTMENT_ORDER: {
    literal: 'EXCEL_SHOPEE_ADJUSTMENT_ORDER',
    label: 'shopee调整费订单维度',
    value: 'EXCEL_SHOPEE_ADJUSTMENT_ORDER'
  },
  EXCEL_SHOPEE_ADJUSTMENT_ORDER_ITEMS: {
    literal: 'EXCEL_SHOPEE_ADJUSTMENT_ORDER_ITEMS',
    label: 'shopee调整费子单维度',
    value: 'EXCEL_SHOPEE_ADJUSTMENT_ORDER_ITEMS'
  },
  EXCEL_SHOPEE_ORDER_REPORT: {
    literal: 'EXCEL_SHOPEE_ORDER_REPORT',
    label: 'shopee订单利润报表',
    value: 'EXCEL_SHOPEE_ORDER_REPORT'
  },
  EXCEL_SHOPEE_ORDER_ITEMS_REPORT: {
    literal: 'EXCEL_SHOPEE_ORDER_ITEMS_REPORT',
    label: 'shopee子单利润报表',
    value: 'EXCEL_SHOPEE_ORDER_ITEMS_REPORT'
  },
  EXCEL_SHOPEE_SKU_REPORT: {
    literal: 'EXCEL_SHOPEE_SKU_REPORT',
    label: 'shopeeSKU利润报表',
    value: 'EXCEL_SHOPEE_SKU_REPORT'
  },
  EXCEL_SHOPEE_SHOP_REPORT: {
    literal: 'EXCEL_SHOPEE_SHOP_REPORT',
    label: 'shopee店铺利润报表',
    value: 'EXCEL_SHOPEE_SHOP_REPORT'
  },
  EXCEL_AMAZON_ORDER_LIST: {
    literal: 'EXCEL_AMAZON_ORDER_LIST',
    label: 'amazon订单列表-简版',
    value: 'EXCEL_AMAZON_ORDER_LIST'
  },
  EXCEL_AMAZON_ORDER_BASIS_LIST: {
    literal: 'EXCEL_AMAZON_ORDER_BASIS_LIST',
    label: 'amazon订单列表-精版',
    value: 'EXCEL_AMAZON_ORDER_BASIS_LIST'
  },
  EXCEL_AMAZON_CRAWLER_KEYWORD_RANK: {
    literal: 'EXCEL_AMAZON_CRAWLER_KEYWORD_RANK',
    label: 'amazon关键词排名',
    value: 'EXCEL_AMAZON_CRAWLER_KEYWORD_RANK'
  },
  // 广告报表
  EXCEL_AMAZON_AD_REPORT: {
    literal: 'EXCEL_AMAZON_AD_REPORT',
    label: 'amazon广告报表导出',
    value: 'EXCEL_AMAZON_AD_REPORT'
  },
  // 广告模块
  EXCEL_AMAZON_AD_ACTIVITY_SEARCH_SEEK_REPORT: {
    literal: 'EXCEL_AMAZON_AD_ACTIVITY_SEARCH_SEEK_REPORT',
    label: 'amazon广告活动导出',
    value: 'EXCEL_AMAZON_AD_ACTIVITY_SEARCH_SEEK_REPORT'
  },
  EXCEL_AMAZON_AD_FIRST_DELIVERY_SEARCH_SEEK_REPORT: {
    literal: 'EXCEL_AMAZON_AD_FIRST_DELIVERY_SEARCH_SEEK_REPORT',
    label: 'amazon广告一级投放导出',
    value: 'EXCEL_AMAZON_AD_FIRST_DELIVERY_SEARCH_SEEK_REPORT'
  },
  EXCEL_AMAZON_AD_FIRST_SEARCH_TERM_SEARCH_SEEK_REPORT: {
    literal: 'EXCEL_AMAZON_AD_FIRST_SEARCH_TERM_SEARCH_SEEK_REPORT',
    label: 'amazon广告一级搜索词导出',
    value: 'EXCEL_AMAZON_AD_FIRST_SEARCH_TERM_SEARCH_SEEK_REPORT'
  },
  EXCEL_AMAZON_AD_GROUP_SEARCH_SEEK_REPORT: {
    literal: 'EXCEL_AMAZON_AD_GROUP_SEARCH_SEEK_REPORT',
    label: 'amazon广告组导出',
    value: 'EXCEL_AMAZON_AD_GROUP_SEARCH_SEEK_REPORT'
  },
  EXCEL_AMAZON_AD_ADVERTISEMENT_SEARCH_SEEK_REPORT: {
    literal: 'EXCEL_AMAZON_AD_ADVERTISEMENT_SEARCH_SEEK_REPORT',
    label: 'amazon广告出',
    value: 'EXCEL_AMAZON_AD_ADVERTISEMENT_SEARCH_SEEK_REPORT'
  },
  EXCEL_AMAZON_AD_PURCHASE_ASIN_SEARCH_SEEK_REPORT: {
    literal: 'EXCEL_AMAZON_AD_PURCHASE_ASIN_SEARCH_SEEK_REPORT',
    label: 'amazon三级购买asin报告导出',
    value: 'EXCEL_AMAZON_AD_PURCHASE_ASIN_SEARCH_SEEK_REPORT'
  },
  EXCEL_AMAZON_AD_THIRTY_SEARCH_SEEK_REPORT: {
    literal: 'EXCEL_AMAZON_AD_THIRTY_SEARCH_SEEK_REPORT',
    label: 'amazon广告三级搜索词导出',
    value: 'EXCEL_AMAZON_AD_THIRTY_SEARCH_SEEK_REPORT'
  },
  EXCEL_AMAZON_AD_TARGET_REPORT: {
    literal: 'EXCEL_AMAZON_AD_TARGET_REPORT',
    label: 'amazon广告三级投放-商品导出',
    value: 'EXCEL_AMAZON_AD_TARGET_REPORT'
  },
  EXCEL_AMAZON_AD_KEYWORD_REPORT: {
    literal: 'EXCEL_AMAZON_AD_KEYWORD_REPORT',
    label: 'amazon广告三级投放-关键词导出',
    value: 'EXCEL_AMAZON_AD_KEYWORD_REPORT'
  },
  EXCEL_AE_ORDER_DETAIL: {
    literal: 'EXCEL_AE_ORDER_DETAIL',
    label: '速卖通订单结算明细',
    value: 'EXCEL_AE_ORDER_DETAIL'
  },
  EXCEL_AE_PRODUCT_DETAIL: {
    literal: 'EXCEL_AE_PRODUCT_DETAIL',
    label: '速卖通子订单结算明细',
    value: 'EXCEL_AE_PRODUCT_DETAIL'
  },
  EXCEL_AE_PROFIT_SHOP: {
    literal: 'EXCEL_AE_PROFIT_SHOP',
    label: '速卖通店铺利润报表',
    value: 'EXCEL_AE_PROFIT_SHOP'
  },
  EXCEL_AE_PROFIT_ORDER: {
    literal: 'EXCEL_AE_PROFIT_ORDER',
    label: '速卖通订单利润报表',
    value: 'EXCEL_AE_PROFIT_ORDER'
  },
  EXCEL_AE_PROFIT_PRODUCT: {
    literal: 'EXCEL_AE_PROFIT_PRODUCT',
    label: '速卖通商品利润报表',
    value: 'EXCEL_AE_PROFIT_PRODUCT'
  },

  FBA_QUANTITY_REPORT: {
    literal: 'FBA_QUANTITY_REPORT',
    label: 'FBA进销存报表数量',
    value: 'FBA_QUANTITY_REPORT'
  },

  FBA_FIFO_COST_MERGE_REPORT: {
    literal: 'FBA_FIFO_COST_MERGE_REPORT',
    label: '先进先出成本报表 成本汇总展示 不显示数量',
    value: 'FBA_FIFO_COST_MERGE_REPORT'
  },

  FBA_FIFO_COST_SPLIT_REPORT: {
    literal: 'FBA_FIFO_COST_SPLIT_REPORT',
    label: '先进先出成本报表 成本分开展示 不显示数量',
    value: 'FBA_FIFO_COST_SPLIT_REPORT'
  },
  FBA_FIFO_COST_AND_QUANTITY_MERGE_REPORT: {
    literal: 'FBA_FIFO_COST_AND_QUANTITY_MERGE_REPORT',
    label: '先进先出成本报表 成本汇总展示 显示数量',
    value: 'FBA_FIFO_COST_AND_QUANTITY_MERGE_REPORT'
  },
  FBA_FIFO_COST_AND_QUANTITY_SPLIT_REPORT: {
    literal: 'FBA_FIFO_COST_AND_QUANTITY_SPLIT_REPORT',
    label: '先进先出成本报表 成本分开展示 显示数量',
    value: 'FBA_FIFO_COST_AND_QUANTITY_SPLIT_REPORT'
  },
  FBA_FIXED_COST_MERGE_REPORT: {
    literal: 'FBA_FIXED_COST_MERGE_REPORT',
    label: '固定值成本报表 成本汇总展示 不显示数量',
    value: 'FBA_FIXED_COST_MERGE_REPORT'
  },
  FBA_FIXED_COST_SPLIT_REPORT: {
    literal: 'FBA_FIXED_COST_SPLIT_REPORT',
    label: '固定值成本报表 成本分开展示 不显示数量',
    value: 'FBA_FIXED_COST_SPLIT_REPORT'
  },
  FBA_FIXED_COST_AND_QUANTITY_MERGE_REPORT: {
    literal: 'FBA_FIXED_COST_AND_QUANTITY_MERGE_REPORT',
    label: '固定值成本报表 成本汇总展示 显示数量',
    value: 'FBA_FIXED_COST_AND_QUANTITY_MERGE_REPORT'
  },
  FBA_FIXED_COST_AND_QUANTITY_SPLIT_REPORT: {
    literal: 'FBA_FIXED_COST_AND_QUANTITY_SPLIT_REPORT',
    label: '固定值成本报表 成本分开展示 显示数量',
    value: 'FBA_FIXED_COST_AND_QUANTITY_SPLIT_REPORT'
  },
  NO_COST_SPEC_REPORT: {
    literal: 'NO_COST_SPEC_REPORT',
    label: 'FBA进销存报表成本-固定值-系统SKU传给固定值模板',
    value: 'NO_COST_SPEC_REPORT'
  },
  FBA_RECEIPTS_COST_REPORT: {
    literal: 'FBA_RECEIPTS_COST_REPORT',
    label: '下载货件计划',
    value: 'FBA_RECEIPTS_COST_REPORT'
  },
  FBA_DAILY_SKU_COST_REPORT: {
    literal: 'FBA_DAILY_SKU_COST_REPORT',
    label: '下载日加权平均报表',
    value: 'FBA_DAILY_SKU_COST_REPORT'
  },
  FBA_ORDER_REPORT: {
    literal: 'FBA_ORDER_REPORT',
    label: '下载FBA销售出库单',
    value: 'FBA_ORDER_REPORT'
  },
  EXCEL_SHOPEE_RECEVIABLEDETAIL: {
    literal: 'EXCEL_SHOPEE_RECEVIABLEDETAIL',
    label: '下载Shopee应收明细',
    value: 'EXCEL_SHOPEE_RECEVIABLEDETAIL'
  },
  EXCEL_AE_RECEIVABLE_NOTES: {
    literal: 'EXCEL_AE_RECEIVABLE_NOTES',
    label: '下载Shopee应收明细',
    value: 'EXCEL_AE_RECEIVABLE_NOTES'
  },
  EXCEL_LAZADA_RECEIVABLE_DETAIL: {
    literal: 'EXCEL_LAZADA_RECEIVABLE_DETAIL',
    label: '下载lazada应收明细',
    value: 'EXCEL_LAZADA_RECEIVABLE_DETAIL'
  },
  EXCEL_AMAZON_PROFIT_STORE_REPORT: {
    literal: 'EXCEL_AMAZON_PROFIT_STORE_REPORT',
    label: '下载店铺利润报表',
    value: 'EXCEL_AMAZON_PROFIT_STORE_REPORT'
  },
  EXCEL_AMAZON_ASIN_PROFIT_REPORT: {
    literal: 'EXCEL_AMAZON_ASIN_PROFIT_REPORT',
    label: '下载ASIN利润报表',
    value: 'EXCEL_AMAZON_ASIN_PROFIT_REPORT'
  },
  EXCEL_AMAZON_MERCHANT_SKU_PROFIT_REPORT: {
    literal: 'EXCEL_AMAZON_MERCHANT_SKU_PROFIT_REPORT',
    label: '下载SKU利润报表',
    value: 'EXCEL_AMAZON_MERCHANT_SKU_PROFIT_REPORT'
  },
  EXCEL_AMAZON_ORDER_PROFIT_REPORT: {
    literal: 'EXCEL_AMAZON_ORDER_PROFIT_REPORT',
    label: '下载订单利润报表',
    value: 'EXCEL_AMAZON_ORDER_PROFIT_REPORT'
  },
  EXCEL_AMAZON_FINANCES_SETTLEMENT: {
    literal: 'EXCEL_AMAZON_FINANCES_SETTLEMENT',
    label: '下载Amazon计算明细',
    value: 'EXCEL_AMAZON_FINANCES_SETTLEMENT'
  },
  EXCEL_CHECK_ACCOUNT_MANAGE: {
    literal: 'EXCEL_CHECK_ACCOUNT_MANAGE',
    label: '下载shopee对账管理',
    value: 'EXCEL_CHECK_ACCOUNT_MANAGE'
  },
  EXCEL_AMAZON_TRAFFIC_PERFORMANCE: {
    literal: 'EXCEL_AMAZON_TRAFFIC_PERFORMANCE',
    label: '下载流量详情报表',
    value: 'EXCEL_AMAZON_TRAFFIC_PERFORMANCE'
  },
  EXCEL_ALL_PLATFOR_SHOP_PORFIT: {
    literal: 'EXCEL_ALL_PLATFOR_SHOP_PORFIT',
    label: '全平台利润报表-利润明细',
    value: 'EXCEL_ALL_PLATFOR_SHOP_PORFIT'
  },
  EXCEL_ALL_PLATFOR_SHOP_PORFIT_REPORT: {
    literal: 'EXCEL_ALL_PLATFOR_SHOP_PORFIT_REPORT',
    label: '全平台利润报表-利润报告',
    value: 'EXCEL_ALL_PLATFOR_SHOP_PORFIT_REPORT'
  },
  EXCEL_AMAZON_FIFO_INITIAL_EXPORT: {
    literal: 'EXCEL_AMAZON_FIFO_INITIAL_EXPORT',
    label: 'FIFO初始化报表',
    value: 'EXCEL_AMAZON_FIFO_INITIAL_EXPORT'
  },
  FIFO_REPORT: {
    literal: 'FIFO_REPORT',
    label: 'FIFO库存成本报表',
    value: 'FIFO_REPORT'
  },
  EXCEL_AMAZON_SHARE_FIRST_TRIP_COST: {
    literal: 'EXCEL_AMAZON_SHARE_FIRST_TRIP_COST',
    label: '头程分摊报表',
    value: 'EXCEL_AMAZON_SHARE_FIRST_TRIP_COST'
  },
  EXCEL_AMAZON_REPLENISHMENT_INVENTORY_ASIN: {
    literal: 'EXCEL_AMAZON_REPLENISHMENT_INVENTORY_ASIN',
    label: 'amazon-补货建议-asin',
    value: 'EXCEL_AMAZON_REPLENISHMENT_INVENTORY_ASIN'
  },
  EXCEL_AMAZON_REPLENISHMENT_ADVICE: {
    literal: 'EXCEL_AMAZON_REPLENISHMENT_ADVICE',
    label: 'amazon-补货建议-msku',
    value: 'EXCEL_AMAZON_REPLENISHMENT_ADVICE'
  },
  EXCEL_AMAZON_STORAGE_CHECKING_OVERVIEW_REPORT: {
    literal: 'EXCEL_AMAZON_STORAGE_CHECKING_OVERVIEW_REPORT',
    label: 'amazon-仓储费-对账-总览',
    value: 'EXCEL_AMAZON_STORAGE_CHECKING_OVERVIEW_REPORT'
  },
  EXCEL_AMAZON_STORAGE_CHECKING_DETAIL_REPORT: {
    literal: 'EXCEL_AMAZON_STORAGE_CHECKING_DETAIL_REPORT',
    label: 'amazon-仓储费-对账-明细',
    value: 'EXCEL_AMAZON_STORAGE_CHECKING_DETAIL_REPORT'
  },
  EXCEL_AMAZON_LIGHTNING_SHARE: {
    literal: 'EXCEL_AMAZON_LIGHTNING_SHARE',
    label: 'amazon-LD费-对账-总览',
    value: 'EXCEL_AMAZON_LIGHTNING_SHARE'
  },
  EXCEL_AMAZON_LIGHTNING_SHARE_DETAIL: {
    literal: 'EXCEL_AMAZON_LIGHTNING_SHARE_DETAIL',
    label: 'amazon-LD费-对账-明细',
    value: 'EXCEL_AMAZON_LIGHTNING_SHARE_DETAIL'
  },
  EXCEL_AMAZON_REMOVAL_SHARE: {
    literal: 'EXCEL_AMAZON_REMOVAL_SHARE',
    label: 'amazon-弃置移除费-对账-总览',
    value: 'EXCEL_AMAZON_REMOVAL_SHARE'
  },
  EXCEL_AMAZON_REMOVAL_SHARE_DETAIL: {
    literal: 'EXCEL_AMAZON_REMOVAL_SHARE_DETAIL',
    label: 'amazon-弃置移除费-对账-明细',
    value: 'EXCEL_AMAZON_REMOVAL_SHARE_DETAIL'
  },
  EXCEL_SHOPEE_PAYOUT: {
    literal: 'EXCEL_SHOPEE_PAYOUT',
    label: 'shopee-回款记录',
    value: 'EXCEL_SHOPEE_PAYOUT'
  },
  EXCEL_SHOPEE_WALLET: {
    literal: 'EXCEL_SHOPEE_WALLET',
    label: 'shopee-回款记录-本土店',
    value: 'EXCEL_SHOPEE_WALLET'
  },
  EXCEL_AMAZON_SALE_SUMMARY: {
    literal: 'EXCEL_AMAZON_SALE_SUMMARY',
    label: '销售统计导出',
    value: 'EXCEL_AMAZON_SALE_SUMMARY'
  },
  EXCEL_AMAZON_SALES_SUMMARY_GOODS_WITH_NOT_SKU: {
    literal: 'EXCEL_AMAZON_SALES_SUMMARY_GOODS_WITH_NOT_SKU',
    label: '销售统计-未匹配导出',
    value: 'EXCEL_AMAZON_SALES_SUMMARY_GOODS_WITH_NOT_SKU'
  },
  EXCEL_AMAZON_FINANCES_RECEIVABLE: {
    literal: 'EXCEL_AMAZON_FINANCES_RECEIVABLE',
    label: 'amazon-回款记录',
    value: 'EXCEL_AMAZON_FINANCES_RECEIVABLE',
  },
  EXCEL_AMAZON_API_FBA_REIMBURSEMENTS: {
    literal: 'EXCEL_AMAZON_API_FBA_REIMBURSEMENTS',
    label: '亚马逊赔偿报告',
    value: 'EXCEL_AMAZON_API_FBA_REIMBURSEMENTS',
  },
  EXCEL_AMAZON_PRODUCT_REVIEW: {
    literal: 'EXCEL_AMAZON_PRODUCT_REVIEW',
    label: '亚马逊赔偿报告',
    value: 'EXCEL_AMAZON_PRODUCT_REVIEW',
  },
  EXCEL_AMAZON_API_FEEDBACK: {
    literal: 'EXCEL_AMAZON_API_FEEDBACK',
    label: '亚马逊-买家评价-Feedback（三星及以下）',
    value: 'EXCEL_AMAZON_API_FEEDBACK',
  },
  EXCEL_AMAZON_SHOP_FEEDBACK: {
    literal: 'EXCEL_AMAZON_SHOP_FEEDBACK',
    label: '亚马逊-买家评价-Feedback（四星及以下）',
    value: 'EXCEL_AMAZON_SHOP_FEEDBACK',
  },
  EXCEL_AMAZON_TRAFFIC_PERFORMANCE_LIST: {
    literal: 'EXCEL_AMAZON_TRAFFIC_PERFORMANCE_LIST',
    label: '亚马逊流量统计',
    value: 'EXCEL_AMAZON_TRAFFIC_PERFORMANCE_LIST',
  },
  EXCEL_AMAZON_API_FBA_LONG_TERM: {
    literal: 'EXCEL_AMAZON_API_FBA_LONG_TERM',
    label: '亚马逊长期仓储费',
    value: 'EXCEL_AMAZON_API_FBA_LONG_TERM',
  },
  EXCEL_AMAZON_REMOVAL_ORDER: {
    literal: 'EXCEL_AMAZON_REMOVAL_ORDER',
    label: '亚马逊移除订单',
    value: 'EXCEL_AMAZON_REMOVAL_ORDER',
  },
  EXCEL_AMAZON_API_CUSTOMER_SHIPMENT_REPLACEMENT: {
    literal: 'EXCEL_AMAZON_API_CUSTOMER_SHIPMENT_REPLACEMENT',
    label: '亚马逊换货订单',
    value: 'EXCEL_AMAZON_API_CUSTOMER_SHIPMENT_REPLACEMENT',
  },
  EXCEL_AMAZON_API_ORDER_RETURNS: {
    literal: 'EXCEL_AMAZON_API_ORDER_RETURNS',
    label: '亚马逊退货订单',
    value: 'EXCEL_AMAZON_API_ORDER_RETURNS',
  },
  EXCEL_AMAZON_API_FBA_INVENTORY_AGED: {
    literal: 'EXCEL_AMAZON_API_FBA_INVENTORY_AGED',
    label: '亚马逊FBA库龄下载',
    value: 'EXCEL_AMAZON_API_FBA_INVENTORY_AGED',
  },
  EXCEL_AMAZON_SHOP_PERFORMANCE: {
    literal: 'EXCEL_AMAZON_SHOP_PERFORMANCE',
    label: '店铺表现',
    value: 'EXCEL_AMAZON_SHOP_PERFORMANCE',
  },
  EXCEL_AMAZON_PRODUCT_ASIN_PERFORMANCE: {
    literal: 'EXCEL_AMAZON_PRODUCT_ASIN_PERFORMANCE',
    label: '商品表现ASIN',
    value: 'EXCEL_AMAZON_PRODUCT_ASIN_PERFORMANCE',
  },
  EXCEL_AMAZON_PRODUCT_MSKU_PERFORMANCE: {
    literal: 'EXCEL_AMAZON_PRODUCT_MSKU_PERFORMANCE',
    label: '商品表现MSKU',
    value: 'EXCEL_AMAZON_PRODUCT_MSKU_PERFORMANCE',
  },
  EXCEL_AMAZON_PRODUCT_PARENT_ASIN_PERFORMANCE: {
    literal: 'EXCEL_AMAZON_PRODUCT_PARENT_ASIN_PERFORMANCE',
    label: '商品表父ASIN',
    value: 'EXCEL_AMAZON_PRODUCT_PARENT_ASIN_PERFORMANCE',
  },
  EXCEL_AMAZON_MONTH_STORAGE: {
    literal: 'EXCEL_AMAZON_MONTH_STORAGE',
    label: '月度仓储费',
    value: 'EXCEL_AMAZON_MONTH_STORAGE',
  },
  EXCEL_ACCOUNT_MANGAGEMENT: {
    literal: 'EXCEL_ACCOUNT_MANGAGEMENT',
    label: '账户管理',
    value: 'EXCEL_ACCOUNT_MANGAGEMENT',
  },
  EXCEL_REQUEST_FUNDS: {
    literal: 'EXCEL_REQUEST_FUNDS',
    label: '费用请款单',
    value: 'EXCEL_REQUEST_FUNDS',
  },
  EXCEL_RECEIPT_PAYMENT: {
    literal: 'EXCEL_RECEIPT_PAYMENT',
    label: '收付款单',
    value: 'EXCEL_RECEIPT_PAYMENT',
  },
  EXCEL_AE_WAREHOUSE_STOCK: {
    literal: 'EXCEL_AE_WAREHOUSE_STOCK',
    label: '速卖通-进销存报表',
    value: 'EXCEL_AE_WAREHOUSE_STOCK',
  },
  EXCEL_AE_PROFIT_COUNTRY: {
    literal: 'EXCEL_AE_PROFIT_COUNTRY',
    label: '速卖通-利润报表-国家',
    value: 'EXCEL_AE_PROFIT_COUNTRY',
  },
  EXCEL_AE_PROFIT_ORDER_ITEM: {
    literal: 'EXCEL_AE_PROFIT_ORDER_ITEM',
    label: '速卖通-利润报表-子订单',
    value: 'EXCEL_AE_PROFIT_ORDER_ITEM',
  },
  EXCEL_AMAZON_FIFO_ORDER: {
    literal: 'EXCEL_AMAZON_FIFO_ORDER',
    label: '批次成本-先进先出',
    value: 'EXCEL_AMAZON_FIFO_ORDER',
  },
  EXCEL_ALL_PLATFORM_ORDER_PROFIT: {
    literal: 'EXCEL_ALL_PLATFORM_ORDER_PROFIT',
    label: '订单利润报表',
    value: 'EXCEL_ALL_PLATFORM_ORDER_PROFIT',
  },
  EXCEL_ALL_PLATFORM_ORDER_ITEMS_PROFIT: {
    literal: 'EXCEL_ALL_PLATFORM_ORDER_ITEMS_PROFIT',
    label: '订单利润报表',
    value: 'EXCEL_ALL_PLATFORM_ORDER_ITEMS_PROFIT',
  },
  EXCEL_ALL_PLATFORM_FINANCE_ORDER_PROFIT: {
    literal: 'EXCEL_ALL_PLATFORM_FINANCE_ORDER_PROFIT',
    label: '月结利润报表-订单',
    value: 'EXCEL_ALL_PLATFORM_FINANCE_ORDER_PROFIT',
  },
  EXCEL_ALL_PLATFORM_FINANCE_ORDER_SKU_PROFIT: {
    literal: 'EXCEL_ALL_PLATFORM_FINANCE_ORDER_SKU_PROFIT',
    label: '月结利润报表-订单明细',
    value: 'EXCEL_ALL_PLATFORM_FINANCE_ORDER_SKU_PROFIT',
  },
  EXCEL_AMAZON_INVENTORY_LIST: {
    literal: 'EXCEL_AMAZON_INVENTORY_LIST',
    label: '亚马逊-fba库存',
    value: 'EXCEL_AMAZON_INVENTORY_LIST',
  },
  EXCEL_WISH_PROFIT_ORDER: {
    literal: 'EXCEL_WISH_PROFIT_ORDER',
    label: 'wish-订单利润报表',
    value: 'EXCEL_WISH_PROFIT_ORDER',
  },
  EXCEL_AE_WAREHOUSE_BATCH: {
    literal: 'EXCEL_AE_WAREHOUSE_BATCH',
    label: '速卖通-批次成本-列表',
    value: 'EXCEL_AE_WAREHOUSE_BATCH',
  },
  EXCEL_AE_WAREHOUSE_DETAIL: {
    literal: 'EXCEL_AE_WAREHOUSE_DETAIL',
    label: '速卖通-仓库-扣减明细',
    value: 'EXCEL_AE_WAREHOUSE_DETAIL',
  },
  EXCEL_AE_WAREHOUSE_COST: {
    literal: 'EXCEL_AE_WAREHOUSE_COST',
    label: '速卖通-仓库-批次成本-下载模板',
    value: 'EXCEL_AE_WAREHOUSE_COST',
  },
  EXCEL_WAREHOUSE_INVENTORY_ITEM: {
    literal: 'EXCEL_WAREHOUSE_INVENTORY_ITEM',
    label: '速卖通-进销存明细-列表',
    value: 'EXCEL_WAREHOUSE_INVENTORY_ITEM',
  },
  EXCEL_WAREHOUSE_INVENTORY_INIT: {
    literal: 'EXCEL_WAREHOUSE_INVENTORY_INIT',
    label: '速卖通-进销存明细-初始化导出',
    value: 'EXCEL_WAREHOUSE_INVENTORY_INIT',
  },
  EXCEL_CHECK_ACCOUNT_FIRST_VESSEL: {
    literal: 'EXCEL_CHECK_ACCOUNT_FIRST_VESSEL',
    label: '头程对账',
    value: 'EXCEL_CHECK_ACCOUNT_FIRST_VESSEL',
  },
  EXCEL_IMPORT_FIRST_VESSEL: {
    literal: 'EXCEL_IMPORT_FIRST_VESSEL',
    label: '物流账单-头程',
    value: 'EXCEL_IMPORT_FIRST_VESSEL',
  },
  EXCEL_WAREHOUSE_INVENTORY_REPORT: {
    literal: 'EXCEL_WAREHOUSE_INVENTORY_REPORT',
    label: '进销存统计',
    value: 'EXCEL_WAREHOUSE_INVENTORY_REPORT',
  },
  EXCEL_TAIL_VESSEL_CENTER: {
    literal: 'EXCEL_TAIL_VESSEL_CENTER',
    label: '物流账单-尾程',
    value: 'EXCEL_TAIL_VESSEL_CENTER',
  },
  EXCEL_COST_ADJUSTMENT_DETAIL: {
    literal: 'EXCEL_COST_ADJUSTMENT_DETAIL',
    label: '成本调整单-列表',
    value: 'EXCEL_COST_ADJUSTMENT_DETAIL',
  },
}

// 异步下载 列 类型
export const ASYNC_EXPORT_COLUMN_TYPE_ENUM = {
  csv: {
    literal: 'csv',
    label: 'csv',
    value: 1,
  },
  excel: {
    literal: 'excel',
    label: 'excel',
    value: 2,
  },
}

/**
 * 异步任务 文件状态
 */
export const ASYNC_EXPORT_FILE_STATUS = {
  init: {
    literal: 'init',
    label: '初始化',
    value: 1,
    bgColorClass: 'processCircleColor',
  },
  generating: {
    literal: 'generating',
    label: '生成中',
    value: 2,
    bgColorClass: 'processCircleColor',
  },
  generated: {
    literal: 'generated',
    label: '已生成',
    value: 3,
    bgColorClass: 'successCircleColor',
  },
  generateError: {
    literal: 'generateError',
    label: '生成失败',
    value: 4,
    bgColorClass: 'failCircleColor',
  },
  generateEmpty: {
    literal: 'generateEmpty',
    label: '无数据',
    value: 5,
  },
}

/**
 *  column 预设类型 of vxe grid
 */
export const HC_COL_PRESET_TYPE_VXE_GRID_ENUM = {
  text: {
    // 居左 显示...
    literal: 'text',
    label: 'text',
    value: 'text',
  },
  amount: {
    // 居右 换行 千分位 两位小数
    literal: 'amount',
    label: 'amount',
    value: 'amount'
  },
  percentage: {
    // 居右 换行
    literal: 'percentage',
    label: 'percentage',
    value: 'percentage'
  },
  quantity: {
    // 居右 换行
    literal: 'quantity',
    label: 'quantity',
    value: 'quantity'
  },
  time: {
    // 居左 空格换行显示
    literal: 'time',
    label: 'time',
    value: 'time'
  },
  operation: {
    // 居左 自动宽度
    literal: 'operation',
    label: 'operation',
    value: 'operation'
  },
  image: {
    // 固定宽度, 图片有气泡
    literal: 'image',
    label: 'image',
    value: 'image'
  },
  checkbox: {
    // 固定宽度, 图片有气泡
    literal: 'checkbox',
    label: '选择框',
    value: 'checkbox'
  },
}

/**
 * 查询条件枚举
 */
export const CONDITION_ENUM = {
  msku: {
    literal: 'msku',
    label: 'MSKU',
    value: 'msku',
  },
  asin: {
    literal: 'asin',
    label: 'ASIN',
    value: 'asin',
  },
  fnSku: {
    literal: 'fnsku',
    label: 'FNSKU',
    value: 'fnsku',
  },
  systemSku: {
    literal: 'systemSku',
    label: '系统SKU',
    value: 'systemSku',
  },
  skuName: {
    literal: 'skuName',
    label: '系统SKU名称',
    value: 'skuName',
  },
  amazonOrderId: {
    literal: 'amazonOrderId',
    label: '订单号',
    value: 'amazonOrderId',
  },
  costFollowShipmentId: {
    literal: 'costFollowShipmentId',
    label: '货件编号',
    value: 'costFollowShipmentId',
  },
  stockNo: {
    literal: 'stockNo',
    label: '库存批次',
    value: 'stockNo',
  },
  specNo: {
    literal: 'specNo',
    label: '系统SKU',
    value: 'specNo',
  },
  specName: {
    literal: 'specName',
    label: '品名',
    value: 'specName',
  },
  spec: {
    literal: 'spec',
    label: '品名/系统SKU',
    value: 'spec',
  },
  orderNo: {
    literal: 'orderNo',
    label: '移除订单号',
    value: 'orderNo',
  },
}

/**
 * 头程分摊类型
 */

export const FIRST_TRIP_SHARE_TYPE = {
  amazonShipmentId: {
    literal: 'amazonShipmentId',
    label: '货件编号',
    value: 'amazonShipmentId',
  },
  transferId: {
    literal: 'transferId',
    label: '调拨单',
    value: 'transferId',
  },
  stockOutNo: {
    literal: 'stockOutNo',
    label: '调拨出库单',
    value: 'stockOutNo',
  },
  logisticsNo: {
    literal: 'logisticsNo',
    label: '运单号',
    value: 'logisticsNo',
  },
}

/**
 * 单号类型
 */
export const ORDER_NO_TYPE_ENUM = {
  systemOrderNo: {
    literal: 'systemOrderNo',
    label: '系统订单号',
    value: 1,
  },
  platformOrderNo: {
    literal: 'platformOrderNo',
    label: '平台订单号',
    value: 2,
  },
  platformChildOrderNo: {
    literal: 'platformChildOrderNo',
    label: '平台子订单号',
    value: 3,
  },
  receivableId: {
    literal: 'receivableId',
    label: '应收ID',
    value: 4,
  },
  reconcileId: {
    literal: 'reconcileId',
    label: '对账ID',
    value: 5,
  },
}

// SKU 搜索类型
export const SKU_SEARCH_TYPE_ENUM = {
  systemSkuCode: {
    literal: 'systemSkuCode',
    label: '系统SKU编码',
    value: 1,
  },
  systemSkuName: {
    literal: 'systemSkuName',
    label: '系统SKU名称',
    value: 2,
  },
  platformSkuCode: {
    literal: 'platformSkuCode',
    label: '平台SKU编码',
    value: 3,
  },
  platformSkuName: {
    literal: 'platformSkuName',
    label: '平台SKU名称',
    value: 4,
  },
  sysGoodsNo: {
    literal: 'sysGoodsNo',
    label: '系统SPU编码',
    value: 5,
  },
  sysGoodsName: {
    literal: 'sysGoodsName',
    label: '系统SPU名称',
    value: 6,
  },
  platformProductCode: {
    literal: 'platformProductCode',
    label: '平台商品编码',
    value: 7,
  },
}

// 应收类型
export const RECEIVALBE_TYPE_ENUM = {
  deliveryReceivable: {
    literal: 'deliveryReceivable',
    label: '发货应收',
    value: 1,
  },
  returnReceivable: {
    literal: 'returnReceivable',
    label: '退回应收',
    value: 2,
  },
  logisticsFeeAdjustment: {
    literal: 'logisticsFeeAdjustment',
    label: '运费调整',
    value: 3,
  },
  receivableAdjustment: {
    literal: 'receivableAdjustment',
    label: '应收调整',
    value: 4,
  },
}

// 对账类型
export const RECONCILE_STATUS_ENUM = {
  waitReconcile: {
    literal: 'waitReconcile',
    label: '待对账',
    value: 0,
    color: '#F5B639',
  },
  reconcileSuccess: {
    literal: 'reconcileSuccess',
    label: '对账成功',
    value: 1,
    color: '#3B6CFF',
  },
  reconcileDifference: {
    literal: 'reconcileDifference',
    label: '对账不一致',
    value: 2,
    color: '#FF4D4A',
  },
  notAssociated: {
    literal: 'notAssociated',
    label: '未关联',
    value: 3,
    color: '#FF4D4A',
  },
}

// 对账状态

/**
 * Fba进销存报表维度
 */
export const CONDITION_FBA_PURCHASE_SELL_STOCK = {
  quantity: {
    literal: 'quantity',
    label: '数量',
    value: 'quantity'
  },
  cost: {
    literal: 'cost',
    label: '成本',
    value: 'cost'
  },
}

/**
 * 广告活动 状态
 */
export const AD_PROMOTION_STATUS_ENUM = {
  enabled: {
    literal: 'enabled',
    label: '投放中',
    value: 'enabled',
  },
  archived: {
    literal: 'archived',
    label: '已存档',
    value: 'archived',
  },
  refused: {
    literal: 'refused',
    label: '审核拒绝',
    value: 'refused',
  },
  reviewing: {
    literal: 'reviewing',
    label: '待审核',
    value: 'reviewing',
  },
  STATUS_UNAVAILABLE: {
    literal: 'STATUS_UNAVAILABLE',
    label: '状态未获取',
    value: 'STATUS_UNAVAILABLE',
  },
  ADVERTISER_STATUS_ENABLED: {
    literal: 'ADVERTISER_STATUS_ENABLED',
    label: '投放中',
    value: 'ADVERTISER_STATUS_ENABLED',
  },
  ADVERTISER_PAUSED: {
    literal: 'ADVERTISER_PAUSED',
    label: '已暂停',
    value: 'ADVERTISER_PAUSED',
  },
  ACCOUNT_OUT_OF_BUDGET: {
    literal: 'ACCOUNT_OUT_OF_BUDGET',
    label: '账户超预算',
    value: 'ACCOUNT_OUT_OF_BUDGET',
  },
  ADVERTISER_PAYMENT_FAILURE: {
    literal: 'ADVERTISER_PAYMENT_FAILURE',
    label: '支付失败',
    value: 'ADVERTISER_PAYMENT_FAILURE',
  },
  CAMPAIGN_STATUS_ENABLED: {
    literal: 'CAMPAIGN_STATUS_ENABLED',
    label: '投放中',
    value: 'CAMPAIGN_STATUS_ENABLED',
  },
  CAMPAIGN_PAUSED: {
    literal: 'CAMPAIGN_PAUSED',
    label: '已暂停',
    value: 'CAMPAIGN_PAUSED',
  },
  CAMPAIGN_ARCHIVED: {
    literal: 'CAMPAIGN_ARCHIVED',
    label: '已归档',
    value: 'CAMPAIGN_ARCHIVED',
  },
  PENDING_START_DATE: {
    literal: 'PENDING_START_DATE',
    label: '准备投放',
    value: 'PENDING_START_DATE',
  },
  ENDED: {
    literal: 'ENDED',
    label: '已结束',
    value: 'ENDED',
  },
  CAMPAIGN_INCOMPLETE: {
    literal: 'CAMPAIGN_INCOMPLETE',
    label: '不完整',
    value: 'CAMPAIGN_INCOMPLETE',
  },
  CAMPAIGN_OUT_OF_BUDGET: {
    literal: 'CAMPAIGN_OUT_OF_BUDGET',
    label: '超预算',
    value: 'CAMPAIGN_OUT_OF_BUDGET',
  },
  PORTFOLIO_PAUSED: {
    literal: 'PORTFOLIO_PAUSED',
    label: '已暂停',
    value: 'PORTFOLIO_PAUSED',
  },
  PORTFOLIO_ARCHIVED: {
    literal: 'PORTFOLIO_ARCHIVED',
    label: '已归档',
    value: 'PORTFOLIO_ARCHIVED',
  },
  PORTFOLIO_OUT_OF_BUDGET: {
    literal: 'PORTFOLIO_OUT_OF_BUDGET',
    label: '超预算',
    value: 'PORTFOLIO_OUT_OF_BUDGET',
  },
  PORTFOLIO_ENDED: {
    literal: 'PORTFOLIO_ENDED',
    label: '已结束',
    value: 'PORTFOLIO_ENDED',
  },
  AD_GROUP_STATUS_ENABLED: {
    literal: 'AD_GROUP_STATUS_ENABLED',
    label: '投放中',
    value: 'AD_GROUP_STATUS_ENABLED',
  },
  AD_GROUP_PAUSED: {
    literal: 'AD_GROUP_PAUSED',
    label: '已暂停',
    value: 'AD_GROUP_PAUSED',
  },
  AD_GROUP_ARCHIVED: {
    literal: 'AD_GROUP_ARCHIVED',
    label: '不完整',
    value: 'AD_GROUP_ARCHIVED',
  },
  AD_GROUP_INCOMPLETE: {
    literal: 'AD_GROUP_INCOMPLETE',
    label: '已归档',
    value: 'AD_GROUP_INCOMPLETE',
  },
  AD_GROUP_LOW_BID: {
    literal: 'AD_GROUP_LOW_BID',
    label: '低竞价',
    value: 'AD_GROUP_LOW_BID',
  },
  AD_STATUS_LIVE: {
    literal: 'AD_STATUS_LIVE',
    label: '投放中',
    value: 'AD_STATUS_LIVE',
  },
  AD_PAUSED: {
    literal: 'AD_PAUSED',
    label: '已暂停',
    value: 'AD_PAUSED',
  },
  AD_ARCHIVED: {
    literal: 'AD_ARCHIVED',
    label: '已归档',
    value: 'AD_ARCHIVED',
  },
  MISSING_IMAGE: {
    literal: 'MISSING_IMAGE',
    label: '缺图片',
    value: 'MISSING_IMAGE',
  },
  MISSING_DECORATION: {
    literal: 'MISSING_DECORATION',
    label: '不可投放',
    value: 'MISSING_DECORATION',
  },
  NOT_BUYABLE: {
    literal: 'NOT_BUYABLE',
    label: '不可售',
    value: 'NOT_BUYABLE',
  },
  NOT_IN_BUYBOX: {
    literal: 'NOT_IN_BUYBOX',
    label: '无购物车',
    value: 'NOT_IN_BUYBOX',
  },
  OUT_OF_STOCK: {
    literal: 'OUT_OF_STOCK',
    label: '无库存',
    value: 'OUT_OF_STOCK',
  },
  TARGETING_CLAUSE_STATUS_LIVE: {
    literal: 'TARGETING_CLAUSE_STATUS_LIVE',
    label: '投放中',
    value: 'TARGETING_CLAUSE_STATUS_LIVE',
  },
  TARGETING_CLAUSE_POLICING_SUSPENDED: {
    literal: 'TARGETING_CLAUSE_POLICING_SUSPENDED',
    label: '不合规',
    value: 'TARGETING_CLAUSE_POLICING_SUSPENDED',
  },
  TARGETING_CLAUSE_PAUSED: {
    literal: 'TARGETING_CLAUSE_PAUSED',
    label: '已暂停',
    value: 'TARGETING_CLAUSE_PAUSED',
  },
  TARGETING_CLAUSE_ARCHIVED: {
    literal: 'TARGETING_CLAUSE_ARCHIVED',
    label: '已归档',
    value: 'TARGETING_CLAUSE_ARCHIVED',
  },
  TARGETING_CLAUSE_BLOCKED: {
    literal: 'TARGETING_CLAUSE_BLOCKED',
    label: '被屏蔽',
    value: 'TARGETING_CLAUSE_BLOCKED',
  },
  NO_INVENTORY: {
    literal: 'NO_INVENTORY',
    label: 'NO_INVENTORY',
    value: 'NO_INVENTORY',
  },
  PENDING_REVIEW: {
    literal: 'PENDING_REVIEW',
    label: '待审核',
    value: 'PENDING_REVIEW',
  },
  pendingReview: {
    literal: 'pendingReview',
    label: '待审核',
    value: 'pendingReview',
  },
  READY: {
    literal: 'READY',
    label: '准备投放',
    value: 'READY',
  },
  SCHEDULED: {
    literal: 'SCHEDULED',
    label: '计划投放',
    value: 'SCHEDULED',
  },
  RUNNING: {
    literal: 'RUNNING',
    label: '投放中',
    value: 'RUNNING',
  },
  running: {
    literal: 'running',
    label: '投放中',
    value: 'running',
  },
  PAUSED: {
    literal: 'PAUSED',
    label: '已暂停',
    value: 'PAUSED',
  },
  paused: {
    literal: 'paused',
    label: '已暂停',
    value: 'paused',
  },
  REJECTED: {
    literal: 'REJECTED',
    label: '已拒绝',
    value: 'REJECTED',
  },
  rejected: {
    literal: 'rejected',
    label: '已拒绝',
    value: 'rejected',
  },
  BILLING_ERROR: {
    literal: 'BILLING_ERROR',
    label: '账单错误',
    value: 'BILLING_ERROR',
  },
  ASIN_NOT_BUYABLE: {
    literal: 'ASIN_NOT_BUYABLE',
    label: '商品不可售',
    value: 'ASIN_NOT_BUYABLE',
  },
  LANDING_PAGE_NOT_AVAILABLE: {
    literal: 'LANDING_PAGE_NOT_AVAILABLE',
    label: '着陆页不存在',
    value: 'LANDING_PAGE_NOT_AVAILABLE',
  },
  landingPageNotAvailable: {
    literal: 'landingPageNotAvailable',
    label: '着陆页不存在',
    value: 'landingPageNotAvailable',
  },
  OUT_OF_BUDGET: {
    literal: 'OUT_OF_BUDGET',
    label: '超预算',
    value: 'OUT_OF_BUDGET',
  },
  PORTFOLIO_STATUS_ENABLED: {
    literal: 'PORTFOLIO_STATUS_ENABLED',
    label: '投放中',
    value: 'PORTFOLIO_STATUS_ENABLED',
  },
  PORTFOLIO_STATUS_PAUSED: {
    literal: 'PORTFOLIO_STATUS_PAUSED',
    label: '已暂停',
    value: 'PORTFOLIO_STATUS_PAUSED',
  },
}

/**
 * 重算更新记录
 */

export const RECOMPUTE_UPDATE_RECODE_ENUM = {
  amazon_shop_profit: {
    literal: 'amazon_shop_profit',
    label: '亚马逊利润报表',
    value: 'amazon_shop_profit',
  },
  shopee_profit: {
    literal: 'shopee_profit',
    label: '虾皮利润报表',
    value: 'shopee_profit',
  },
  lazada_profit: {
    literal: 'lazada_profit',
    label: 'lazada利润报表',
    value: 'lazada_profit',
  },
  aliexpress_profit: {
    literal: 'aliexpress_profit',
    label: '速卖通利润报表',
    value: 'aliexpress_profit',
  },
  amazon_detail: {
    literal: 'amazon_detail',
    label: '亚马逊结算明细',
    value: 'amazon_detail',
  },
  shopee_detail: {
    literal: 'shopee_detail',
    label: '虾皮结算明细',
    value: 'shopee_detail',
  },
  lazada_detail: {
    literal: 'lazada_detail',
    label: 'lazada结算明细',
    value: 'lazada_detail',
  },
  aliexpress_detail: {
    literal: 'aliexpress_detail',
    label: '速卖通结算明细',
    value: 'aliexpress_detail',
  },
  lazada_fees: {
    literal: 'lazada_fees',
    label: 'lazada费用明细',
    value: 'lazada_fees',
  },
  shopee_receivable: {
    literal: 'shopee_receivable',
    label: 'shopee应收明细',
    value: 'PLATFORM_RECEIVABLE:11',
  },
  lazada_receivable: {
    literal: 'lazada_receivable',
    label: 'shopee应收明细',
    value: 'PLATFORM_RECEIVABLE:2',
  },
  ali_receivable: {
    literal: 'ali_receivable',
    label: 'shopee应收明细',
    value: 'PLATFORM_RECEIVABLE:1',
  },
  esa_platform_check: {
    literal: 'esa_platform_check',
    label: '东南亚平台对账',
    value: 'esa_platform_check',
  },
  ALIEXPRESS_COST: {
    literal: 'ALIEXPRESS_COST',
    label: '速卖通批次成本',
    value: 'ALIEXPRESS_COST',
  },
}

// 订单状态
export const LAZADA_CHILD_ORDER_STATUS_ENUM = {
  delivered: {
    literal: 'delivered',
    label: 'Delivered',
    value: 1
  },
  deliveryFailed: {
    literal: 'deliveryFailed',
    label: 'Delivery Failed',
    value: 2
  },
  lostBy3pl: {
    literal: 'lostBy3pl',
    label: 'lost by 3pl',
    value: 3
  },
  returned: {
    literal: 'returned',
    label: 'Returned',
    value: 4
  },
}

// Lazada 平台订单状态
export const LAZADA_PLATFORM_ORDER_STATUS_ENUM = {
  unknown: {
    literal: 'unknown',
    label: '未知',
    value: 5
  },
  notConfirm: {
    literal: 'notConfirm',
    label: '未确认',
    value: 10
  },
  waitPay: {
    literal: 'waitPay',
    label: '待尾款',
    value: 20
  },
  riskControling: {
    literal: 'riskControling',
    label: '风控中',
    value: 25
  },
  waitDelivery: {
    literal: 'waitDelivery',
    label: '待发货',
    value: 30
  },
  deliverySection: {
    literal: 'deliverySection',
    label: '部分发货',
    value: 40
  },
  delivered: {
    literal: 'delivered',
    label: '已发货',
    value: 50
  },
  signedReceived: {
    literal: 'signedReceived',
    label: '已签收',
    value: 60
  },
  completed: {
    literal: 'completed',
    label: '已完成',
    value: 70
  },
  returnedMoney: {
    literal: 'returnedMoney',
    label: '已退款 ',
    value: 80
  },
  closed: {
    literal: 'closed',
    label: '已关闭 ',
    value: 90
  },
}

// Lazada 平台订单状态
export const AE_PLATFORM_ORDER_STATUS_ENUM = {
  PLACE_ORDER_SUCCESS: {
    literal: 'PLACE_ORDER_SUCCESS',
    label: '等待买家付款',
    value: 'PLACE_ORDER_SUCCESS'
  },
  IN_CANCEL: {
    literal: 'IN_CANCEL',
    label: '买家申请取消',
    value: 'IN_CANCEL'
  },
  WAIT_SELLER_SEND_GOODS: {
    literal: 'WAIT_SELLER_SEND_GOODS',
    label: '等待您发货',
    value: 'WAIT_SELLER_SEND_GOODS'
  },
  SELLER_PART_SEND_GOODS: {
    literal: 'SELLER_PART_SEND_GOODS',
    label: '部分发货',
    value: 'SELLER_PART_SEND_GOODS'
  },
  WAIT_BUYER_ACCEPT_GOODS: {
    literal: 'WAIT_BUYER_ACCEPT_GOODS',
    label: '等待买家收货',
    value: 'WAIT_BUYER_ACCEPT_GOODS'
  },
  FUND_PROCESSING: {
    literal: 'FUND_PROCESSING',
    label: '已退款',
    value: 'FUND_PROCESSING'
  },
  IN_ISSUE: {
    literal: 'IN_ISSUE',
    label: '含纠纷中的订单',
    value: 'IN_ISSUE'
  },
  IN_FROZEN: {
    literal: 'IN_FROZEN',
    label: '冻结中的订单',
    value: 'IN_FROZEN'
  },
  WAIT_SELLER_EXAMINE_MONEY: {
    literal: 'WAIT_SELLER_EXAMINE_MONEY',
    label: '等待您确认金额',
    value: 'WAIT_SELLER_EXAMINE_MONEY'
  },
  PAYMENT_PROCESSING: {
    literal: 'PAYMENT_PROCESSING',
    label: '支付处理中',
    value: 'PAYMENT_PROCESSING'
  },
  RISK_CONTROL: {
    literal: 'RISK_CONTROL',
    label: '风控中',
    value: 'RISK_CONTROL'
  },
  FINISH: {
    literal: 'FINISH',
    label: '已结束',
    value: 'FINISH'
  },
}

// LAZADA 结算状态
export const LAZADA_SETTLEMENT_STATUS_ENUM = {
  settlmented: {
    literal: 'checked',
    label: '已结算',
    value: 1
  },
  settlmentedSection: {
    literal: 'checkedSection',
    label: '部分结算',
    value: 2
  },
  notsettlment: {
    literal: 'notCheck',
    label: '未结算',
    value: 3
  },
}

// lazada 配送方式
export const LAZADA_DELIVERY_WAY_ENUM = {
  sellerDelivery: {
    literal: 'sellerDelivery',
    label: '商家配送',
    value: 1,
  },
  platformDelivery: {
    literal: 'platformDelivery',
    label: '平台配送',
    value: 2,
  },
  platformSellerDelivery: {
    literal: 'platformSellerDelivery',
    label: '平台&商家配送',
    value: 4,
  },
}
// LAZADA 退款状态
export const LAZADA_REFUND_STATUS_ENUM = {
  unknown: {
    literal: 'unknown',
    label: '未知',
    value: 0,
  },
  applying: {
    literal: 'applying',
    label: '申请中',
    value: 1,
  },
  applyAccepted: {
    literal: 'applyAccepted',
    label: '接受申请',
    value: 2,
  },
  canceled: {
    literal: 'canceled',
    label: '已取消',
    value: 3,
  },
  controversial: {
    literal: 'controversial',
    label: '争议',
    value: 4,
  },
  refundSuccess: {
    literal: 'refundSuccess',
    label: '退款成功',
    value: 5,
  },
  closed: {
    literal: 'closed',
    label: '已关闭',
    value: 6,
  },
  goodsReturning: {
    literal: 'goodsReturning',
    label: '退货中',
    value: 7,
  },
  sellerControversial: {
    literal: 'sellerControversial',
    label: '卖家争议',
    value: 8,
  },
  applyRejected: {
    literal: 'applyRejected',
    label: '申请拒绝',
    value: 9,
  },
  refunding: {
    literal: 'refunding',
    label: '退款中',
    value: 10,
  },
  refundRejected: {
    literal: 'refundRejected',
    label: '拒绝退款',
    value: 11,
  },
  goodsReturnRejected: {
    literal: 'goodsReturnRejected',
    label: '拒绝退货',
    value: 12,
  },
  goodsReturnButRefundReject: {
    literal: 'goodsReturnButRefundReject',
    label: '退货拒绝退款',
    value: 13,
  },
  goodsReturnAndRefund: {
    literal: 'unknown',
    label: '退货同意退款',
    value: 14,
  },
  goodsExchanging: {
    literal: 'goodsExchanging',
    label: '换货中',
    value: 15,
  },
  goodsEchangingSuccess: {
    literal: 'goodsEchangingSuccess',
    label: '换货成功',
    value: 16,
  },
  cancelSuccess: {
    literal: 'cancelSuccess',
    label: '取消成功',
    value: 17,
  },
}
// LAZADA 二次销售状态
export const LAZADA_RESALES_ENUM = {
  yes: {
    literal: 'yes',
    label: '是',
    value: 1,
  },
  no: {
    literal: 'no',
    label: '否',
    value: -1,
  },
  section: {
    literal: 'section',
    label: '部分',
    value: 2,
  },
}

// LAZADA 子单类型
export const LAZADA_TRADE_TYPE_ENUM = {
  platformOrderType: {
    literal: 'platformOrderType',
    label: '平台订单',
    value: 1,
  },
  swapOutOrderType: {
    literal: 'swapOutOrderType',
    label: '换出订单',
    value: 3,
  },
  resendOrderType: {
    literal: 'resendOrderType',
    label: '重发订单',
    value: 4,
  },
  giftOrderType: {
    literal: 'giftOrderType',
    label: '赠品订单',
    value: 10,
  },
}

// 应收明细 - 导入状态
export const IMPORT_STATUS_ENUM = {
  importSucceed: {
    literal: 'importSucceed',
    label: '导入成功',
    value: 300,
  },
  importFailed: {
    literal: 'importFailed',
    label: '导入失败',
    value: -300,
  },
  processing: {
    literal: 'processing',
    label: '解析中',
    value: 0,
  },
  fileFailure: {
    literal: 'fileFailure',
    label: '文件失效',
    value: 200,
  },
  partialSuccess: {
    literal: 'partialSuccess',
    label: '部分成功',
    value: 200,
  },
}

// 对账管理 - 核销状态
export const VERIFICATION_STATUS_ENUM = {
  verificationSucceed: {
    literal: 'verificationSucceed',
    label: '核销成功',
    value: 1,
    color: '#59C922',
  },
  verificationFailed: {
    literal: 'verificationFailed',
    label: '核销失败',
    value: 3,
    color: '#FF4D4A',
  },
  processing: {
    literal: 'processing',
    label: '核销中',
    value: 2,
    color: '#3B6CFF',
  },
}

// 核销记录 - 备注
export const REMARK_STATUS_ENUM = {
  remark: {
    literal: 'remark',
    label: '备注',
    value: 1,
  }
}

export const PLATFORM_ENUM_ALL = {
  amazon: {
    literal: 'amazon',
    label: 'Amazon',
    name: '亚马逊',
    value: AmazonId,
  },
  aliExpress: {
    literal: '',
    label: 'AliExpress',
    name: '速卖通',
    value: AliExpressId,
  },
  shopee: {
    literal: 'shopee',
    label: 'Shopee',
    name: '虾皮',
    value: ShopeeId,
  },
  lazada: {
    literal: 'lazada',
    label: 'Lazada',
    name: '拉赞达',
    value: LazadaId,
  },
  offline: {
    literal: 'offline',
    label: '线下',
    name: '线下',
    value: 0,
  },
  wish: {
    literal: 'wish',
    label: 'Wish',
    name: 'Wish',
    value: 5,
  },
}

export const ACCURATE_FUZZY_ENUM = {
  accurate: {
    literal: 'accurate',
    label: '精准',
    value: 1,
  },
  fuzzy: {
    literal: 'fuzzy',
    label: '模糊',
    value: 2,
  },
}

export const DATE_RANGE_TYPE_ENUM = {
  minute: {
    literal: 'minute',
    label: '分',
    value: 1,
  },
  hour: {
    literal: 'hour',
    label: '时',
    value: 2,
  },
  day: {
    literal: 'day',
    label: '日',
    value: 3,
  },
  month: {
    literal: 'month',
    label: '月',
    value: 4,
  },
  week: {
    literal: 'week',
    label: '周',
    value: 5,
  },
  year: {
    literal: 'year',
    label: '年',
    value: 6,
  },
}

export const EXACT_BLUR_ENUM = {
  exact: {
    literal: 'exact',
    label: '精准',
    value: 1,
  },
  blur: {
    literal: 'blur',
    label: '模糊',
    value: 2,
  },
}

// AE 库存类型
export const AE_STOCK_TYPE_ENUM = {
  good: {
    literal: 'good',
    label: '良品',
    value: 1,
  },
  bad: {
    literal: 'bad',
    label: '残品',
    value: 101,
  },
}

// 核销记录的状态
export const CHECK_RECORDS_STATUS_ENUM = {
  wait: {
    literal: 'wait',
    label: '待核销',
    value: 0,
    color: '#F5B639',
  },
  success: {
    literal: 'success',
    label: '核销成功',
    value: 1,
    color: '#3B6CFF',
  },
  checking: {
    literal: 'checking',
    label: '核销中',
    value: 2,
    color: '#3B6CFF',
  },
  failure: {
    literal: 'failure',
    label: '核销失败',
    value: 3,
    color: '#FF4D4A',
  },
}

// 拨款状态
export const ALLOCATE_FUNDS_STATUS_ENUM = {
  yes: {
    literal: 'yes',
    label: '已拨款',
    value: 0,
    color: '#F5B639',
  },
  no: {
    literal: 'no',
    label: '未拨款',
    value: 1,
    color: '#F5B639',
  },
}

// LAZADA 二次销售状态
export const YES_NO_ENUM = {
  yes: {
    literal: 'yes',
    label: '是',
    value: 1,
  },
  no: {
    literal: 'no',
    label: '否',
    value: 2,
  },
}

// 仓储费类型 amazon
export const WAREHOUSE_CHARGES_TYPE_AMAZON_ENUM = {
  monthly: {
    literal: 'monthly',
    label: '月度仓储费',
    value: 0,
  },
  longtime: {
    literal: 'longtime',
    label: '长期仓储费',
    value: 1,
  },
  overbalance: {
    literal: 'overbalance',
    label: '超量仓储费',
    value: 2,
  },
}

// 差异分摊状态 amazon
export const APPORTION_STATUS_AMAZON_ENUM = {
  no: {
    literal: 'monthly',
    label: '无分摊',
    value: 0,
  },
  already: {
    literal: 'longtime',
    label: '已分摊',
    value: 1,
  },
}

export const DIFF_STATUS_ENUM = {
  yes: {
    literal: 'yes',
    label: '有差异',
    value: 1,
  },
  no: {
    literal: 'no',
    label: '无差异',
    value: 2,
  },
  processing: {
    literal: 'processing',
    label: '处理中',
    value: 3,
  },
}

// 收款渠道 shopee
export const PAY_SERVICE_SHOPEE_ENUM = {
  payoneer: {
    literal: 'payoneer',
    label: 'payoneer',
    value: 'payoneer',
  },
  pingpong: {
    literal: 'pingpong',
    label: 'pingpong',
    value: 'pingpong',
  },
  lianlian: {
    literal: 'lianlian',
    label: 'lianlian',
    value: 'lianlian',
  },
}

/**
 * 速卖通 导入账单类型
 */
export const AE_IMPORT_BILL_TYPE_ENUM = {
  financeAlipayAccountBalance: {
    literal: 'financeAlipayAccountBalance',
    label: '财务动账',
    value: 1,
  },
  jzgBillDetail: {
    literal: 'jzgBillDetail',
    label: '金掌柜账单',
    value: 2,
  },
  russiaBill: {
    literal: 'russiaBill',
    label: '俄罗斯账单',
    value: 3,
  },
}

/**
 * 速卖通 无物流费异常类型
 */
export const AE_NO_LOGISTICS_FEE_EXCEPT_TYPE_ENUM = {
  // success: {
  //   label: '成功获取物流费',
  //   value: 0,
  //   literal: 'success',
  // },
  offlineDelivery: {
    label: '线下发货',
    value: 1,
    literal: 'offlineDelivery',
  },
  overseaWarehouse: {
    label: '海外仓',
    value: 4,
    literal: 'overseaWarehouse',
  },
  waitDelivery: {
    label: '等待商家发货',
    value: 5,
    literal: 'overseaWarehouse',
  },
  notStockOut: {
    label: '已发货未出仓',
    value: 2,
    literal: 'notStockOut',
  },
  aePlatformApiNoReturn: {
    label: '平台接口异常',
    value: 3,
    literal: 'aePlatformApiNoReturn',
  },
}
/**
 * 往来单位类型
 */
export const CORRESPONDENCE_COMPANY_TYPE_ENUM = {
  supplier: {
    literal: 'supplier',
    label: '供应商',
    value: 1
  },
  customer: {
    literal: 'customer',
    label: '客户',
    value: 2
  },
  other: {
    literal: 'other',
    label: '其他',
    value: 3
  },
}
/**
 * 关联单据类型
 */
export const LINK_TICKET_TYPE_ENUM = {
  purchaseWarehouse: {
    literal: 'purchaseWarehouse',
    label: '采购入库单',
    value: 7
  }
}
/**
 * 费用请款单 请款状态
 */
export const REQUEST_FUNDS_STATUS_TYPE_ENUM = {
  draft: {
    literal: 'draft',
    label: '草稿',
    value: 0,
  },
  pendingReview: {
    literal: 'pendingReview',
    label: '待审核',
    value: 1,
  },
  reject: {
    literal: 'reject',
    label: '已驳回',
    value: 2,
  },
  pendingPayment: {
    literal: 'pendingPayment',
    label: '待付款',
    value: 3,
  },
  paid: {
    literal: 'paid',
    label: '已付款',
    value: 4,
  },
}

/**
 * shopee 订单类型
 */
export const SHOPEE_ORDER_TYPE_ENUM = {
  exchange: {
    literal: 'exchange',
    label: '换货',
    value: 3,
  },
  reDelivery: {
    literal: 'reDelivery',
    label: '重发',
    value: 4,
  },
  normal: {
    literal: 'normal',
    label: '常规',
    value: 8,
  },
  sip: {
    literal: 'sip',
    label: 'SIP',
    value: 9,
  },
  gift: {
    literal: 'gift',
    label: '赠品',
    value: 10,
  },

}

/**
 * listing 管理 操作日志类型
 */
export const AMAZON_LISTING_MGT_OPERATION_TYPE = {
  modifyPrice: {
    literal: 'modifyPrice',
    label: '修改价格',
    value: 1,
  },
  modifyDiscountsPrice: {
    literal: 'modifyDiscountsPrice',
    label: '修改优惠价',
    value: 2,
  },
  modifyFbmInventory: {
    literal: 'modifyFbmInventory',
    label: '修改FBA库存',
    value: 3,
  },
  modifyProductsTitle: {
    literal: 'modifyProductsTitle',
    label: '修改商品标题',
    value: 4,
  },
  modifyProductFeat: {
    literal: 'modifyProductFeat',
    label: '修改商品特征',
    value: 5,
  },
  modifyProductDesc: {
    literal: 'modifyProductDesc',
    label: '修改商品描述',
    value: 6,
  },
  modifyKeyword: {
    literal: 'modifyKeyword',
    label: '修改关键词',
    value: 7,
  },

}

/**
 * listing 管理 操作 状态
 */
export const AMAZON_LISTING_MGT_OPERATION_STATUS_ENUM = {
  done: {
    literal: 'done',
    label: '成功',
    value: 'DONE',
  },
  fatal: {
    literal: 'fatal',
    label: '失败',
    value: 'FATAL',
  },
  inProgress: {
    literal: 'inProgress',
    label: '处理中',
    value: 'IN_PROGRESS',
  },
  inQueue: {
    literal: 'inQueue',
    label: '队列中',
    value: 'IN_QUEUE',
  },

}

/**
 * 回款记录-异常账期
 */
export const ABNORMAL_PAYMENT_DAYS_MATCH_STATUS_ENUM = {
  unmatch: {
    literal: 'unmatch',
    label: '未匹配',
    value: 'UNMATCH',
  },
  matched: {
    literal: 'matched',
    label: '已匹配',
    value: 'MATCHED',
  }
}

/**
 * listing 管理 修改状态
 */
export const AMAZON_LISTING_MGT_MODIFY_ITEM_STATUS_ENUM = {
  done: {
    literal: 'done',
    label: '成功',
    value: 'DONE',
  },
  inProgress: {
    literal: 'inProgress',
    label: '处理中',
    value: 'IN_PROGRESS',
  },
  inQueue: {
    literal: 'inQueue',
    label: '待处理',
    value: 'IN_QUEUE',
  },
  cancelled: {
    literal: 'cancelled',
    label: '失败',
    value: 'CANCELLED',
  },
  fatal: {
    literal: 'fatal',
    label: '失败',
    value: 'FATAL',
  },

}

// fba 发运方式
export const TRANSFER_TYPE_ENUM = {
  0: '空运',
  1: '海运',
  2: '陆运',
}

export const INCOME_OUTCOME_ENUM = {
  income: {
    literal: 'income',
    label: '收入',
    value: 1,
  },
  outcome: {
    literal: 'outcome',
    label: '支出',
    value: 2,
  },
}

export const WAREHOUSE_TYPE_ENUM = {
  fba: {
    literal: 'fba',
    label: 'FBA仓库',
    value: 1,
  },
  normal: {
    literal: 'normal',
    label: '常规仓库',
    value: 2,
  },
}

export const WISH_ORDER_STATUS_ENUM = {
  canceled: {
    literal: 'canceled',
    label: '已取消',
    value: 5,
  },
  waitPlatformShip: {
    literal: 'waitPlatformShip',
    label: '待平台配送',
    value: 7,
  },
  waitPay: {
    literal: 'waitPay',
    label: '待付款',
    value: 10,
  },
  waitPayTail: {
    literal: 'waitPayTail',
    label: '待尾款',
    value: 12,
  },
  riskControlling: {
    literal: 'riskControlling',
    label: '风控中',
    value: 13,
  },
  handleBeforeGift: {
    literal: 'handleBeforeGift',
    label: '前处理(赠品，合并，拆分)',
    value: 20,
  },
  waitGrab: {
    literal: 'waitGrab',
    label: '待抢单',
    value: 27,
  },
  waitAutoReview: {
    literal: 'waitAutoReview',
    label: '待自动审核',
    value: 29,
  },
  waitReview: {
    literal: 'waitReview',
    label: '待审核',
    value: 30,
  },
  waitFinanceReview: {
    literal: 'waitFinanceReview',
    label: '待财审',
    value: 35,
  },
  waitToWarehouse: {
    literal: 'waitToWarehouse',
    label: '待递交仓库',
    value: 40,
  },
  sendingToWarehouse: {
    literal: 'sendingToWarehouse',
    label: '递交仓库中',
    value: 45,
  },
  alreadySendWarehouse: {
    literal: 'alreadySendWarehouse',
    label: '已递交仓库',
    value: 53,
  },
  reviewed: {
    literal: 'reviewed',
    label: '已审核',
    value: 55,
  },
  notConfirm: {
    literal: 'notConfirm',
    label: '未确认',
    value: 63,
  },
  confirmed: {
    literal: 'confirmed',
    label: '已确认',
    value: 65,
  },
  shipped: {
    literal: 'shipped',
    label: '已发货',
    value: 95,
  },
  waitTypePlanCost: {
    literal: 'waitTypePlanCost',
    label: '待录入计划成本',
    value: 96,
  },
  checked: {
    literal: 'checked',
    label: '已过账',
    value: 101,
  },
  completed: {
    literal: 'completed',
    label: '已完成',
    value: 110,
  },
  shipError: {
    literal: 'shipError',
    label: '异常发货',
    value: 113,
  },
}

export const AE_INVENTORY_ACTIVITY_TYPE_ENUM = {
  normalPurchase: {
    literal: 'normalPurchase',
    label: '普通采购',
    value: 'po0',
  },
  adjustment: {
    literal: 'adjustment',
    label: '盘点调整',
    value: 'adj1',
  },
  salesReturn: {
    literal: 'salesReturn',
    label: '销售退货',
    value: 'rso0 toc',
  },
  systemAdjustment: {
    literal: 'systemAdjustment',
    label: '系统调账',
    value: 'sys1',
  },
  stockInit: {
    literal: 'stockInit',
    label: '库存初始化',
    value: 'STOCK INIT',
  },
  erpAdjust: {
    literal: 'adjust',
    label: 'ERP调整',
    value: 'ADJUST',
  },
}

/**
 * 速卖通 库存活动类型 扣减明细场景
 */
export const AE_INVENTORY_ACTIVITY_TYPE_DEDUCTION_DETAIL_ENUM = {
  scrap: {
    literal: 'scrap',
    label: '报废',
    value: 'ADJ0',
  },
  adjustment: {
    literal: 'adjustment',
    label: '盘点调整',
    value: 'ADJ1',
  },
  systemAdjustment: {
    literal: 'systemAdjustment',
    label: '系统调账',
    value: 'SYS1',
  },
  salesOutToc: {
    literal: 'salesOutToc',
    label: 'TOC销售出库',
    value: 'SO0',
  },
  salesOutTob: {
    literal: 'salesOutTob',
    label: 'TOB销售出库',
    value: 'SO1',
  },
  supplyAgain: {
    literal: 'supplyAgain',
    label: '补发',
    value: 'SO4',
  },
  purchaseReturn: {
    literal: 'purchaseReturn',
    label: '采购退货',
    value: 'RTV0',
  },
  statusAdjustment: {
    literal: 'statusAdjustment',
    label: '状态调整',
    value: 'ADJ2',
  },
}

export const AE_INVENTORY_ACTIVITY_STATUS_ENUM = {
  notStarted: {
    literal: 'notStarted',
    label: '未开始',
    value: 0,
  },
  deducting: {
    literal: 'deducting',
    label: '扣减中',
    value: 1,
  },
  deductDone: {
    literal: 'deductDone',
    label: '已扣完',
    value: 2,
  },
}

/**
 * 头程对账 对账状态
 */
export const FIRST_CARRY_COST_CHECK_STATUS = {
  wait: {
    literal: 'wait',
    label: '待对账',
    value: 0,
    color: '#F5B639',
  },
  success: {
    literal: 'success',
    label: '对账成功',
    value: 1,
    color: '#3B6CFF',
  },
  diff: {
    literal: 'diff',
    label: '对账不一致',
    value: 2,
    color: '#FF4D4A',
  },
  notLink: {
    literal: 'notLink',
    label: '未关联',
    value: 3,
    color: '#FF4D4A',
  },
  verificationProcessing: {
    literal: 'verificationProcessing',
    label: '核销中',
    value: 4,
    color: '#616366',
  },
}

/**
 * 头程对账 物流方式
 */
export const FIRST_CARRY_COST_CHECK_TRANSFER_TYPE_ENUM = {
  air: {
    literal: 'air',
    label: '空运',
    value: 0,
  },
  sea: {
    literal: 'sea',
    label: '海运',
    value: 1,
  },
  land: {
    literal: 'land',
    label: '陆运',
    value: 2,
  },
}

/**
 * 头程对账 物流方式
 */
export const VERIFICATION_RECORDS_BUSINESS_FLAG_ENUM = {
  financeCheck: {
    literal: 'financeCheck',
    label: '财务对账',
    value: 1,
  },
  firstCarryCostCheck: {
    literal: 'firstCarryCostCheck',
    label: '头程对账',
    value: 2,
  },
}

/**
 * 物流账单 调拨类型
 */
export const LOGISTICS_BILL_ALLOCATE_TYPE = {
  fba: {
    literal: 'fba',
    label: 'FBA调拨',
    value: 1,
  },
  other: {
    literal: 'other',
    label: '其他调拨',
    value: 2,
  },
}

/**
 * 物流账单 导入状态
 */
export const LOGISTICS_BILL_IMPORT_STATUS_ENUM = {
  success: {
    literal: 'success',
    label: '导入成功',
    value: 1,
  },
  failure: {
    literal: 'failure',
    label: '导入失败',
    value: 2,
  },
  processing: {
    literal: 'processing',
    label: '解析中',
    value: 3,
  },
  fileInvalid: {
    literal: 'fileInvalid',
    label: '文件失效',
    value: 4,
  },
}

/**
 * 进销存明细 业务类型
 */
export const PSS_DETAIL_BIZ_TYPE_ENUM = {
  purchaseIn: {
    literal: 'purchaseIn',
    label: '采购入库',
    value: 1,
  },
  allocateIn: {
    literal: 'allocateIn',
    label: '调拨入库',
    value: 2,
  },
  returnIn: {
    literal: 'returnIn',
    label: '退货入库',
    value: 3,
  },
  inventoryProfitIn: {
    literal: 'inventoryProfitIn',
    label: '盘盈入库',
    value: 4,
  },
  directReturnIn: {
    literal: 'directReturnIn',
    label: '直接退货入库',
    value: 5,
  },
  otherIn: {
    literal: 'otherIn',
    label: '其他入库',
    value: 6,
  },
  thirdPartyWarehouseInitIn: {
    literal: 'thirdPartyWarehouseInitIn',
    label: '三方仓初始化入库',
    value: 9,
  },
  wmsIn: {
    literal: 'wmsIn',
    label: 'WMS入库',
    value: 12,
  },
  fbaAllocateIn: {
    literal: 'fbaAllocateIn',
    label: 'FBA调拨入库',
    value: 14,
  },
  composeIn: {
    literal: 'composeIn',
    label: '组装入库',
    value: 15,
  },
  normalWarehouseInitIn: {
    literal: 'normalWarehouseInitIn',
    label: '普通仓初始化入库',
    value: 17,
  },
  salesOut: {
    literal: 'salesOut',
    label: '销售出库',
    value: -1,
  },
  allocateOut: {
    literal: 'allocateOut',
    label: '调拨出库',
    value: -2,
  },
  purchaseReturnOut: {
    literal: 'purchaseReturnOut',
    label: '采购退货出库',
    value: -3,
  },
  inventoryLossesOut: {
    literal: 'inventoryLossesOut',
    label: '盘亏出库',
    value: -4,
  },
  otherOut: {
    literal: 'otherOut',
    label: '其他出库',
    value: -7,
  },
  wmsOut: {
    literal: 'wmsOut',
    label: 'WMS出库',
    value: -12,
  },
  composeOut: {
    literal: 'composeOut',
    label: '组装出库',
    value: -15,
  },
  stockInAdjust: {
    literal: 'stockInAdjust',
    label: '入库调整',
    value: 100,
  },
  startAdjust: {
    literal: 'startAdjust',
    label: '期初调整',
    value: 101,
  },
  endAdjust: {
    literal: 'endAdjust',
    label: '期末调整',
    value: 102,
  },
  startBalance: {
    literal: 'startBalance',
    label: '期初结存',
    value: 201,
  },
  endBalance: {
    literal: 'endBalance',
    label: '期末结存',
    value: 202,
  },
}

/**
 * 成本调整单 类型
 */
export const COST_ADJUST_BILL_TYPE = {
  start: {
    literal: 'start',
    label: '期初调整',
    value: 1,
  },
  end: {
    literal: 'end',
    label: '期末调整',
    value: 2,
  },
  stockInNo: {
    literal: 'stockInNo',
    label: '入库单调整',
    value: 3,
  },
}

// 一般操作类型
export const NORMAL_OPT_TYPE_ENUM = {
  create: {
    literal: 'create',
    label: '新增',
    value: 'create',
  },
  detail: {
    literal: 'detail',
    label: '详情',
    value: 'detail',
  },
  update: {
    literal: 'update',
    label: '修改',
    value: 'update',
  },
  del: {
    literal: 'del',
    label: '删除',
    value: 'del',
  },
  check: {
    literal: 'check',
    label: '审核',
    value: 'check',
  },
}

/**
 * 成本调整单 状态
 */
export const COST_ADJUST_BILL_STATUS = {
  waiting: {
    literal: 'waiting',
    label: '待审核',
    value: 1,
  },
  checked: {
    literal: 'checked',
    label: '已审核',
    value: 3,
  },
  rejected: {
    literal: 'rejected',
    label: '已驳回',
    value: 2,
  },
}

/**
 * 结账 操作类型
 */
export const CHECK_OUT_OPT_TYPE_ENUM = {
  settle: {
    literal: 'settle',
    label: '结账',
    value: 'settle',
  },
  reSettle: {
    literal: 'reSettle',
    label: '反结账',
    value: 'reSettle',
  },
  costing: {
    literal: 'costing',
    label: '成本计算',
    value: 'costing',
  },
}

/**
 * 异常项解决方案类型
 */
export const EXCEPTION_RESOLUTION_TYPE = {
  text: {
    literal: 'text',
    label: '提示文案',
    value: 1,
  },
  link: {
    literal: 'link',
    label: '跳转连接',
    value: 2,
  },
  asyncDownload: {
    literal: 'asyncDownload',
    label: '异步下载',
    value: 3,
  },
  other: {
    literal: 'other',
    label: '其他',
    value: 4,
  },
}
